import React from 'react';

const Info = ({ info, infoRef }) => {
  return (
    <div ref={infoRef}>
      {info.eventDescription && (
        <div
          className="t5 mb-25 event-description"
          dangerouslySetInnerHTML={{ __html: info.eventDescription }}
        />
      )}

      {info.additionalDetailCheck && (
        <div>
          <p className="t5 w3 mb-10">Additional details</p>
          <div className="description">
            <div className="full-text">
              <div
                className="t5 text-content mb-10"
                dangerouslySetInnerHTML={{ __html: info.additionalDetails }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Info;
